import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconCommissonsComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Commissons${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M8.654 7.984h5.704c.38 0 .677.33.639.708a7.019 7.019 0 01-7.78 6.264c-3.21-.354-5.818-2.963-6.173-6.173a7.02 7.02 0 016.264-7.78.643.643 0 01.708.638v5.706c0 .352.285.637.638.637z"/><path d="M14.417 6.833H9.75a.583.583 0 01-.583-.583V1.583c0-.322.261-.583.583-.583A5.256 5.256 0 0115 6.25a.583.583 0 01-.583.583z"/></svg>;
}

const IconCommissons = React.forwardRef(IconCommissonsComponent);
export default IconCommissons;
